export function getMiddleTitle({ contact, appConfig }) {
  let string = "";

  if (appConfig.showJobTitle === true && contact.jobTitle) string += contact.jobTitle;

  if (contact.externalId) string += ` (${contact.externalId})`;

  return string;
}
